<mat-spinner
  *ngIf="gettingNewComponent"
  color="primary"
  diameter="48"
></mat-spinner>
<create-view-base-project
  *ngIf="subProject.type === 'BaseProject'"
  [project]="project"
  [subProject]="subProject"
  [submitProjectResult]="submitProjectResult"
  [client]="client"
  [adminCreate]="adminCreate"
  (submitProject)="doSubmitProject()"
  (updateOtherContacts)="emitUpdateOtherContacts($event)"
></create-view-base-project>
<create-view-adjustment
  *ngIf="
    subProject.type === 'Adjustment' ||
    subProject.type === 'SoldRented' ||
    subProject.type === 'Repo'
  "
  [project]="project"
  [subProject]="subProject"
  (submitProject)="doSubmitProject()"
></create-view-adjustment>
